import { Component } from '@angular/core';
import { footer } from 'src/app/core/translate/language';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  languageText = footer;
}
